import { datadogRum } from '@datadog/browser-rum-slim';
import { EvaluationCallback } from 'statsig-js/dist/StatsigSDKOptions';

export const rumStatsigEvaluationCallback: EvaluationCallback = (args) => {
    if (args.type === 'experiment') {
        const key = args.config.getName();
        const value = args.config.getGroupName();
        datadogRum.addFeatureFlagEvaluation(key, value);
    }
};
